import axios from "axios";
import router from "@/router/router";

const BASE_URL = process.env.VUE_APP_NIREX_API_URL + "/customer";

const FREQUENTS_PATH = "/frequents";
const CARDS_PATH = "/cards";
const ORDERS_PATH = "/orders";
const ORDERS_PATH_SAMEDAY = "/sameday/orders";

axios.defaults.baseURL = BASE_URL;

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      router.replace({ name: "Logout" });
    }
    return Promise.reject(err);
  }
);

export function setHeaderAuth(token) {
  axios.defaults.headers.common.Authorization = "Bearer " + token;
}

export default {
  login(data, cb) {
    manageRes(axios.post("/login", data), cb);
  },

  register(data, cb) {
    manageRes(axios.post("/register", data), cb);
  },

  registerMotorized(data, cb) {
    manageRes(axios.post("/registerMotorized", data), cb);
  },

  passwordReset(data, cb) {
    manageRes(axios.post("/password-reset", data), cb);
  },

  passwordChange(data, cb) {
    manageRes(axios.post("/password-change", data), cb);
  },
  tracking(id, cb) {
    manageRes(
      axios.get(`${process.env.VUE_APP_NIREX_API_URL}/tracking?order=${id}`),
      cb
    );
  },
  customer() {
    return axios("/");
  },

  culqi(data, cb) {
    manageRes(
      axios.post("/culqi", data, {
        headers: {
          Key: data.apiKey,
          "Content-Type": "application/json",
        },
      }),
      cb
    );
  },

  update(data, cb) {
    manageRes(axios.put("/update", data), cb);
  },

  changePassword(data, cb) {
    manageRes(axios.put("/change-password", data), cb);
  },

  getApiKey(id, cb) {
    manageRes(axios.get("/generarApikey?idCustomer=" + id), cb);
  },
  getReportOrders(cb) {
    manageRes(
      axios.get(
        process.env.VUE_APP_NIREX_API_URL + "/api/report-ordenes-tipo-servicio"
      ),
      cb
    );
  },
  getReportServices(cb) {
    manageRes(
      axios.get(process.env.VUE_APP_NIREX_API_URL + "/api/report-ordenes-48h"),
      cb
    );
  },

  getAvailableServices(cb) {
    manageRes(
      axios.get(process.env.VUE_APP_NIREX_API_URL + "/api/available-services"),
      cb
    );
  },

  cards: {
    create(payload, cb) {
      const { data, apikey } = payload;
      manageRes(
        axios.post(CARDS_PATH, data, {
          headers: {
            Key: apikey,
            "Content-Type": "application/json",
          },
        }),
        cb
      );
    },

    delete(data, cb) {
      manageRes(axios.post(CARDS_PATH + "/deleteCard", data), cb);
    },
  },

  frequents: {
    getAll(params, cb) {
      manageRes(axios(FREQUENTS_PATH, { params }), cb);
    },

    create(data, cb) {
      manageRes(axios.post(FREQUENTS_PATH, data), cb);
    },

    delete(id, cb) {
      manageRes(axios.delete(FREQUENTS_PATH + "/" + id), cb);
    },
  },

  orders: {
    getAll() {
      return axios(ORDERS_PATH);
    },
    getMercadoFlexOrdersFromApi() {
      return axios.get(
        `${process.env.VUE_APP_NIREX_API_URL}/customer/orders/mercadoflex`
      );
    },
    get(id, cb) {
      manageRes(axios(ORDERS_PATH + "/" + id), cb);
    },

    create(data, cb) {
      manageRes(axios.post(ORDERS_PATH, data), cb);
    },
    createSameday(data, cb) {
      manageRes(
        axios.post(
          `${process.env.VUE_APP_NIREX_API_URL}/api/sameday/orders`,
          data,
          {
            headers: {
              Key: data.apikey,
              "Content-Type": "application/json",
            },
          }
        ),
        cb
      );
    },
    createExpress(data, cb) {
      manageRes(
        axios.post(
          `${process.env.VUE_APP_NIREX_API_URL}/api/express/orders`,
          data,
          {
            headers: {
              Key: data.apikey,
              "Content-Type": "application/json",
            },
          }
        ),
        cb
      );
    },
    createExpressReserved(data, cb) {
      manageRes(
        axios.post(
          `${process.env.VUE_APP_NIREX_API_URL}/api/express/orders/reserved`,
          data,
          {
            headers: {
              Key: data.apikey,
              "Content-Type": "application/json",
            },
          }
        ),
        cb
      );
    },
    createMercadoFlex(data, cb) {
      manageRes(
        axios.post(
          `${process.env.VUE_APP_NIREX_API_URL}/api/mercadoflex/sameday/orders`,
          data,
          {
            headers: {
              Key: data.apikey,
              "Content-Type": "application/json",
            },
          }
        ),
        cb
      );
    },
    update(id, data, cb) {
      manageRes(axios.put(`${ORDERS_PATH}/${id}/update`, data), cb);
    },

    cancelOrder(id, taxes, cb) {
      manageRes(axios.put(`${ORDERS_PATH}/cancel/${id}/${taxes}`), cb);
    },

    pay(id, data, cb) {
      manageRes(axios.post(ORDERS_PATH + "/" + id, data), cb);
    },
  },
  matchTokenApiKey(data, cb) {
    manageRes(
      axios.post(
        `${process.env.VUE_APP_NIREX_API_URL}/api/mercadoflex/register`,
        data,
        {
          headers: {
            Key: data.apikey,
            "Content-Type": "application/json",
          },
        }
      ),
      cb
    );
  },
  unlinkMercadoflexIntegration(data, cb) {
    manageRes(
      axios.post(
        `${process.env.VUE_APP_NIREX_API_URL}/api/mercadoflex/unsuscribe`,
        data.data,
        {
          headers: {
            Key: data.apiKey,
            "Content-Type": "application/json",
          },
        }
      ),
      cb
    );
  },
  createMercadoPagoClient(payload, cb) {
    const { data, apikey } = payload;
    manageRes(
      axios.post(BASE_URL + "/mercadoPago/createClient", data, {
        headers: {
          Key: apikey,
          "Content-Type": "application/json",
        },
      }),
      cb
    );
  },
  getOrdersFromMercadoFlex() {
    return axios.get(
      `${process.env.VUE_APP_NIREX_API_URL}/customer/orders/mercadoflex/pending`
    );
  },
};

function manageRes(xhr, cb) {
  xhr
    .then((res) => {
      cb(null, res.data);
    })
    .catch((err) => {
      cb(err);
    });
}
